import axios from "axios";
import { useEffect, useState } from "react";
import { delete_activation_code, get_activation_codes } from "../../../../api/api";


const EditUploadCodes = ({ haveActivationKey, subjectBranchId, setUploadedFiles, uploadedFiles }) => {

    const [deletingId, setDeletingId] = useState(null);
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const getActivationCodes = async () => {
            try {
                setLoading(true)
                const res = await axios.get(get_activation_codes(subjectBranchId))
                setUploadedFiles(res.data)
            } finally {
                setLoading(false)
            }
        }

        if (haveActivationKey === true) {
            getActivationCodes()
        }
    }, [])



    const handleDelete = async (mediaId) => {
        setDeletingId(mediaId);
        try {
            await axios.delete(delete_activation_code(mediaId))
            setUploadedFiles(prev => prev.filter(f => f.mediaId !== mediaId));
        } finally {
            setDeletingId(null);
        }
    };


    return (<>
        {uploadedFiles.length > 0 && (
            <div className="mt-3">
                <span className="mb-1 d-block">لیست فایل های کدفعالسازی آپلود شده:</span>
                {uploadedFiles.map((file) => (
                    <div
                        key={file.mediaId}
                        className="d-flex align-items-center justify-content-between gap-2"
                    >
                        <input type="text" readOnly value={file.fileName} style={{ fontWeight: 300 }} />
                        <button
                            onClick={() => handleDelete(file.mediaId)}
                            className="removeFileBtn"
                            type="button"
                            disabled={deletingId === file.mediaId}
                        >
                            {deletingId === file.mediaId ? 'لطفا صبر کنید...' : 'حذف فایل'}
                        </button>
                    </div>
                ))}

            </div>
        )}

    </>);
}

export default EditUploadCodes;